import z from "zod";

export type SupportedCurrencies = "usd" | "eur" | "try" | "sar";
export type CurrencyField = "priceUsd" | "priceEur" | "priceTry" | "priceSar";
export type MinMaxCurrencyField = `min${Capitalize<CurrencyField>}`;
export type CurrencySign = "$" | "€" | "₺" | "⃁";

export const CurrencyEnum = z.enum(["usd", "eur", "try", "sar"]);
export const CurrencyValues = CurrencyEnum.options;

export const CurrencyMap = {
  usd: { min: "minPriceUsd", price: "priceUsd" },
  eur: { min: "minPriceEur", price: "priceEur" },
  sar: { min: "minPriceSar", price: "priceSar" },
  try: { min: "minPriceTry", price: "priceTry" },
} as const;

export const CurrencySignMap = {
  usd: "$",
  eur: "€",
  try: "₺",
  sar: "﷼",
} as const;

export const currencyDetails = [
  { code: "usd", sign: "$", nativeName: "US Dollar", name: "US Dollar" },
  { code: "eur", sign: "€", nativeName: "Euro", name: "Euro" },
  { code: "try", sign: "₺", nativeName: "Türk Lirası", name: "Turkish Lira" },
  { code: "sar", sign: "﷼", nativeName: "ريال سعودي", name: "Saudi Riyal" },
] as const;
